import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string { return encodeURIComponent(key); }
  encodeValue(value: string): string { return encodeURIComponent(value); }
  decodeKey(key: string): string { return decodeURIComponent(key); }
  decodeValue(value: string): string { return decodeURIComponent(value); }
}

@Injectable()
export class IndicadorVendaVarejoService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/indicador_venda`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    origem?: any,
    partNumber?: any,
    documento?: any,
    original?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/indicador_venda/'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams({ encoder: new CustomHttpParamEncoder() })
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('origem', origem.toString())
        .set('partNumber', partNumber ? partNumber.toString().trim() : '')
        .set('documento', documento.toString())
        .set('original', original ? original.toString() : '')
    });
  }
}
